import { useState } from "react";
import { intl } from "LocaleWrapper";
import { Button, FormGroup, Select, showSnackbar } from "@cofano/cck";
import { Box } from "@mui/material";
import { CallTimeSource } from "view/maps/utils/MapUtils";

interface MapSettingsProps {
	callTimeSource: CallTimeSource;
	saveCallTimeSource: (value: CallTimeSource) => void;
}

const MapSettings = ({ callTimeSource, saveCallTimeSource }: MapSettingsProps) => {

	const [ callTimeSourceOption, setCallTimeSourceOption ] = useState(callTimeSource);

	const save = () => {
		saveCallTimeSource(callTimeSourceOption);
		showSnackbar(intl.formatMessage({ id: "SUCCESSFUL_SAVED" }), { variant: "success" });
	};

	return (
		<Box p={2}>
			<FormGroup label={intl.formatMessage({ id: "CALL_TIME_CALCULATION" })}>
				<Select
					fetchOptions={Object.values(CallTimeSource)}
					value={callTimeSourceOption}
					onChange={(value) => {
						if (value) {
							setCallTimeSourceOption(value);
						}
					}}
					getOptionLabel={option => option === CallTimeSource.Status ? intl.formatMessage({ id: "STATUS" }) : intl.formatMessage({ id: "CALL_CALCULATED" })}
					clearable={false}
					disableSearch />
			</FormGroup>

			<Button size="small" onClick={save}>
				{intl.formatMessage({ id: "SAVE" })}
			</Button>
		</Box>
	);
};

export default MapSettings;
